module.exports = __webpack_public_path__ + "img/aslp-logo.d4cf5233.png";